<template>
  <v-app style="background-color: #f5f5f5;">
    <v-container style="max-width: 680px;" class="py-8">

      <!-- ローディング -->
      <div v-if="loading" class="text-center py-16">
        <v-progress-circular indeterminate color="primary" />
      </div>

      <!-- 見つからない -->
      <div v-else-if="!profile" class="text-center py-16">
        <v-icon size="64" color="grey lighten-1">mdi-account-off-outline</v-icon>
        <div class="text-h6 grey--text mt-4">プロフィールが見つかりません</div>
        <div class="body-2 grey--text mt-2">URLが間違っているか、非公開になっています</div>
        <v-btn color="primary" depressed class="mt-6" to="/">資格管理アプリを使ってみる</v-btn>
      </div>

      <!-- プロフィール本体 -->
      <template v-else>
        <!-- ヘッダー -->
        <div class="text-center mb-8">
          <v-icon size="56" color="primary">mdi-certificate-outline</v-icon>
          <div class="text-h5 font-weight-bold mt-3">資格ポートフォリオ</div>
          <div class="d-flex justify-center mt-3" style="gap: 16px;">
            <v-chip small color="primary" outlined>
              取得済み {{ profile.acquired ? profile.acquired.length : 0 }}件
            </v-chip>
            <v-chip small color="secondary" outlined>
              勉強中 {{ profile.studying ? profile.studying.length : 0 }}件
            </v-chip>
          </div>
        </div>

        <!-- 取得済み -->
        <template v-if="profile.acquired && profile.acquired.length">
          <div class="text-subtitle-1 font-weight-bold mb-3">
            <v-icon small color="primary" class="mr-1">mdi-badge-account-horizontal</v-icon>
            取得済み
          </div>
          <v-card flat class="mb-6 rounded-lg">
            <template v-for="(item, index) in profile.acquired">
              <v-divider v-if="index > 0" :key="`div-${index}`" />
              <v-list-item :key="`item-${index}`">
                <v-list-item-avatar color="primary">
                  <v-icon dark small>mdi-check</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">{{ item.name }}</v-list-item-title>
                  <v-list-item-subtitle v-if="item.shutokubi">
                    <v-chip x-small label class="mr-1">取得日</v-chip>
                    {{ item.shutokubi }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-card>
        </template>

        <!-- 勉強中 -->
        <template v-if="profile.studying && profile.studying.length">
          <div class="text-subtitle-1 font-weight-bold mb-3">
            <v-icon small color="secondary" class="mr-1">mdi-book-open-variant</v-icon>
            勉強中
          </div>
          <v-card flat class="mb-6 rounded-lg">
            <template v-for="(item, index) in profile.studying">
              <v-divider v-if="index > 0" :key="`div-${index}`" />
              <v-list-item :key="`item-${index}`">
                <v-list-item-avatar color="secondary">
                  <v-icon dark small>mdi-book-open-variant</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">{{ item.name }}</v-list-item-title>
                  <v-list-item-subtitle v-if="item.shikenbi">
                    <v-chip x-small label class="mr-1">試験日</v-chip>
                    {{ item.shikenbi }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-card>
        </template>

        <!-- CTA -->
        <v-card flat color="primary" dark class="rounded-lg pa-6 text-center mt-4">
          <div class="font-weight-bold mb-2">あなたの資格も管理しよう</div>
          <div class="body-2 mb-4 opacity-80">取得済み・勉強中の資格を無料で一元管理</div>
          <v-btn color="white" depressed class="primary--text font-weight-bold" href="https://shikaku-kanri.com">
            無料で使ってみる
          </v-btn>
        </v-card>
      </template>

    </v-container>
  </v-app>
</template>

<script>
  import { funcGetPublicProfile } from '../functions/fb-modules'

  export default {
    name: 'PublicProfile',
    data: () => ({
      loading: true,
      profile: null,
    }),
    async created () {
      const token = this.$route.params.token
      try {
        this.profile = await funcGetPublicProfile(token)
      } catch (e) {
        this.profile = null
      } finally {
        this.loading = false
      }
    },
  }
</script>
